export const PRICING_BY_COUNTRY = {
  NG: {
    pricingCountryCode: "NG",
    pricingLabel: "Nigeria",
    currency: "NGN",
    locale: "en-NG",
    isFallback: false,
    plans: {
      lite: { monthly: 6000, yearly: 66000 },
      pro: { monthly: 8000, yearly: 88000 },
    },
    addons: {
      seats: 5000,
      capacity: 15000,
      storage: 10000,
      streaming: 21000,
      ai_credits: 8000,
    },
  },

  KE: {
    pricingCountryCode: "KE",
    pricingLabel: "Kenya",
    currency: "KES",
    locale: "en-KE",
    isFallback: false,
    plans: {
      lite: { monthly: 1400, yearly: 15400 },
      pro: { monthly: 2100, yearly: 23100 },
    },
    addons: {
      seats: 900,
      capacity: 2600,
      storage: 1600,
      streaming: 1800,
      ai_credits: 1300,
    },
  },

  GH: {
    pricingCountryCode: "GH",
    pricingLabel: "Ghana",
    currency: "GHS",
    locale: "en-GH",
    isFallback: false,
    plans: {
      lite: { monthly: 165, yearly: 1800 },
      pro: { monthly: 240, yearly: 2640 },
    },
    addons: {
      seats: 105,
      capacity: 300,
      storage: 180,
      streaming: 210,
      ai_credits: 150,
    },
  },

  SO: {
    pricingCountryCode: "SO",
    pricingLabel: "Somalia",
    currency: "SOS",
    locale: "en-SO",
    isFallback: false,
    plans: {
      lite: { monthly: 6250, yearly: 68400 },
      pro: { monthly: 9100, yearly: 100100 },
    },
    addons: {
      seats: 4000,
      capacity: 11500,
      storage: 6800,
      streaming: 8000,
      ai_credits: 5700,
    },
  },

  US: {
    pricingCountryCode: "US",
    pricingLabel: "United States",
    currency: "USD",
    locale: "en-US",
    isFallback: false,
    plans: {
      lite: { monthly: 10.99, yearly: 120 },
      pro: { monthly: 15.99, yearly: 175 },
    },
    addons: {
      seats: 7,
      capacity: 20,
      storage: 12,
      streaming: 14,
      ai_credits: 10,
    },
  },

  GLOBAL: {
    pricingCountryCode: "GLOBAL",
    pricingLabel: "International",
    currency: "USD",
    locale: "en-US",
    isFallback: false,
    plans: {
      lite: { monthly: 10.99, yearly: 120 },
      pro: { monthly: 15.99, yearly: 175 },
    },
    addons: {
      seats: 7,
      capacity: 20,
      storage: 12,
      streaming: 14,
      ai_credits: 10,
    },
  },
};

export const getPricingForCountry = (countryCode) => {
  const normalized = String(countryCode || "").toUpperCase();
  return PRICING_BY_COUNTRY[normalized] || PRICING_BY_COUNTRY.GLOBAL;
};
